import { createSlice } from '@reduxjs/toolkit';

export interface IForgotState {
  show: boolean;
}

export const initialState: IForgotState = {
  show: false,
};

export const forgotSlice = createSlice({
  name: 'forgot',
  initialState,
  reducers: {
    show(state) {
      state.show = true;
    },
    close(state) {
      state.show = false;
    },
  },
});
